import { HapticsConfiguration } from '@frontend/sports/common/client-config-data-access';

type PickEvents = 'pick-tap' | 'pick-remove';
type CashoutEvents = 'cashout-start' | 'cashout-confirm' | 'cashout-success' | 'cashout-fail';
type BetslipEvents = 'betplacement-start' | 'betplacement-success' | 'betplacement-fail';
type NumpadEvents = 'numpad-key';
type SliderEvents = 'slider-slide';

export type HapticAction = PickEvents | CashoutEvents | BetslipEvents | NumpadEvents | SliderEvents;

export type HapticsConfigurationOnly = Omit<HapticsConfiguration, 'whenReady' | 'isConfigReady'>;
export type HapticPattern = 'small' | 'mediumlight' | 'medium' | 'heavylight' | 'heavy' | 'mediumlightx2' | 'mediumx2' | 'heavylightx2' | 'heavyx2';
export type iOSHapticFeedbackModel = { type: 'light' | 'medium' | 'heavy' | 'soft' | 'rigid'; strength: 0.5 | 1; count: number };

export const defaultHapticsConfig: Readonly<HapticsConfigurationOnly> = {
    isEnabled: false,
    actionWithPattern: {},
};

export const webPattern: Readonly<Record<HapticPattern, number[]>> = {
    small: [1],
    mediumlight: [1],
    medium: [1],
    heavylight: [1],
    heavy: [1],
    mediumx2: [1, 1, 1],
    mediumlightx2: [1, 1, 1],
    heavyx2: [1, 1, 1],
    heavylightx2: [1, 1, 1],
};

export const defaultiOSPattern: Readonly<iOSHapticFeedbackModel> = {
    type: 'soft',
    strength: 1,
    count: 1,
};

export const iOSPattern: Readonly<Record<HapticPattern, iOSHapticFeedbackModel>> = {
    small: defaultiOSPattern,
    mediumlight: {
        type: 'medium',
        strength: 0.5,
        count: 1,
    },
    medium: {
        type: 'medium',
        strength: 1,
        count: 1,
    },
    heavylight: {
        type: 'heavy',
        strength: 0.5,
        count: 1,
    },
    heavy: {
        type: 'heavy',
        strength: 1,
        count: 1,
    },
    mediumlightx2: {
        type: 'medium',
        strength: 0.5,
        count: 2,
    },
    mediumx2: {
        type: 'medium',
        strength: 1,
        count: 2,
    },
    heavylightx2: {
        type: 'heavy',
        strength: 0.5,
        count: 2,
    },
    heavyx2: {
        type: 'heavy',
        strength: 1,
        count: 2,
    },
};
